import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PayrollProcessService } from 'app/core/services/payroll-process.service';
import { RefreshHolidayService } from 'app/core/services/refresh-holiday/refresh-holiday.service';

@Component({
  selector: 'dialog-doc-action',
  templateUrl: './dialog-doc-action.component.html',
  styleUrls: ['./dialog-doc-action.component.scss']
})
export class DialogDocActionComponent implements OnInit {

  isLoading: boolean = false;
  statusList: any[] = [];
  status: string = '';

  constructor(public dialogRef: MatDialogRef<DialogDocActionComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private payrollProcessService: PayrollProcessService,
    private refreshHolidayService: RefreshHolidayService,
    private fb: FormBuilder) {
  }

  ngOnInit(): void {
    if (this.data.docStatus === 'In Progress') {
      this.status = 'IP';
    }
    if (this.data.docStatus === 'Completed') {
      this.status = 'CO';
    }
    this.getDocStatuses();
  }

  getDocStatuses() {
    this.payrollProcessService.getDocStatuses().subscribe({
      next: res => {
        this.statusList = res;
      }
    })
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  save() {
    this.isLoading = true;
    this.payrollProcessService.docActionProcess(this.status, this.data.id).subscribe({
      next: res => {
        this.refreshHolidayService.emitRefresh3(this.data.index);
        this.isLoading = false;
        this.dialogRef.close();
      },
      error: err => {
        console.log(err);
        this.isLoading  = false;
      }
    })
  }
}
